/**
 * The suggestion box's display name — Charles will rename it (2026-08-06).
 * Change it HERE and the hub tile, desktop rail, and page header all
 * follow. Routes and API paths deliberately use the neutral "box" so a
 * rename never breaks a bookmark.
 */
export const BOX_NAME = 'Suggestion Box'
export const BOX_DESC = 'Suggestions, gripes, and bright ideas'
